module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 data-text="context-header" class="module-title">'+
((__t=( i18n.tc("ControlAccessory", "Accessories") ))==null?'':__t)+
'</h5><i class="icon icon-material icon-expand"></i></header></a><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div id="accessories-error"><p v-show="model.modelError" class="error">{{ model.modelError }}</p><p v-show="model.allAccessoriesError" class="error">{{ model.allAccessoriesError }}</p></div><div data-region="accessories-container"></div><div data-region="groupByZone-container"><div data-region="unconfigured"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Unconfigured") ))==null?'':__t)+
'</h5><div data-region="accessories-unconfigured"></div></div><div data-region="zone1"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Zone 1") ))==null?'':__t)+
' ('+
((__t=( zone1Alias ))==null?'':__t)+
')</h5><div data-region="accessories-zone1"></div></div><div data-region="zone2"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Zone 2") ))==null?'':__t)+
' ('+
((__t=( zone2Alias ))==null?'':__t)+
')</h5><div data-region="accessories-zone2"></div></div><div data-region="zone3"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Zone 3") ))==null?'':__t)+
' ('+
((__t=( zone3Alias ))==null?'':__t)+
')</h5><div data-region="accessories-zone3"></div></div><div data-region="zone4"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Zone 4") ))==null?'':__t)+
' ('+
((__t=( zone4Alias ))==null?'':__t)+
')</h5><div data-region="accessories-zone4"></div></div><div data-region="zone5"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Zone 5") ))==null?'':__t)+
' ('+
((__t=( zone5Alias ))==null?'':__t)+
')</h5><div data-region="accessories-zone5"></div></div><div data-region="zone6"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Zone 6") ))==null?'':__t)+
' ('+
((__t=( zone6Alias ))==null?'':__t)+
')</h5><div data-region="accessories-zone6"></div></div><div data-region="other"><h5>'+
((__t=( i18n.tc("ControlAccessory", "Other") ))==null?'':__t)+
'</h5><div data-region="accessories-other"></div></div></div><div data-region="new-accessory-container"><p><em><small>'+
((__t=(i18n.tc('ControlAccessories', 'This list will show the products that are wirelessly connected to your control unit. Here you can read which zone the accessory is assigned to, and in some cases set the zone for the product. You may read the serial number of each accessory, read the last radio contact your control unit had with the accessory, battery information (if relevant) and other information. You can also pair and unpair accessories.')))==null?'':__t)+
' </small></em></p><div class="align-right"><button type="button" data-click="accessory-refresh">'+
((__t=(i18n.tc('ControlAccessories', 'Refresh')))==null?'':__t)+
'</button> <button type="button" data-click="add-new-accessory">'+
((__t=(i18n.tc('ControlAccessories', 'Add new accessory')))==null?'':__t)+
'</button></div></div></div></div>';
}
return __p;
};
